const formatFurnishing = (furnished) => {
  if (!furnished) return "";

  const value = furnished.trim().toLowerCase();

  if (value === "furnished" || value === "fully furnished") {
    return "fully furnished";
  }
  if (value === "semi furnished") {
    return "semi furnished";
  }
  if (value === "unfurnished") {
    return "unfurnished";
  }

  return value;
};

const formatTitleCase = (text) => {
  if (!text) return "";

  return text
    .split(" ")
    .filter(Boolean)
    .map((word) => {
      const lower = word.toLowerCase();

      if (lower === "in") {
        return "in";
      }

      if (/^\d+$/.test(word)) {
        return word;
      }

      if (/^[A-Z]{2,}$/.test(word)) {
        return word;
      }

      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
};

export const getPropertyImageAlt = ({
  imageIndex = 0,
  bhkType,
  furnished,
  location,
  city,
  listingType = "rent",
}) => {
  const bhk = (bhkType || "").trim();
  const furnishing = formatFurnishing(furnished);
  const propertyWord = listingType === "buy" ? "apartments" : "flats";
  const listingPhrase =
    listingType === "buy" ? "for sale in" : "for rent in";
  const area = (location || "").trim();
  const cityName = (city || "").trim();

  const description = [
    bhk,
    furnishing,
    `${propertyWord} ${listingPhrase}`,
    area,
    cityName,
  ]
    .filter(Boolean)
    .join(" ");

  return `${formatTitleCase(description)} - ${imageIndex + 1}`;
};
